// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-5b0f86d8] .vxe-body--row {\n  height: 100px !important;\n}\n[data-v-5b0f86d8] .vxe-body--column {\n  max-height: 100px !important;\n}\n[data-v-5b0f86d8] .vxe-cell {\n  max-height: 100px !important;\n}\n[data-v-5b0f86d8] .c--tooltip {\n  max-height: 100px !important;\n}\n", ""]);
// Exports
module.exports = exports;
